var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.387 16.998l.001-.04c.01-.22.057-.579.057-.579h.095c.08 0 .144.064.144.144V23.8c0 .08-.064.144-.143.144h-.12c-.005-.002-.022-.028-.034-.307l-.002-5.171c0-.786 0-1.37.002-1.467zM.406 21.467c-.009-.221-.057-.58-.057-.58H.255a.143.143 0 00-.144.145v4.462c.001.08.1.146.18.146h.083c.004-.002.022-.028.033-.306l.002-2.968c0-.443 0-.78-.002-.86v-.039zM.406 15.413c-.009-.221-.057-.58-.057-.58H.255a.143.143 0 00-.144.145v4.462c.001.08.1.146.18.146h.083c.004-.002.022-.028.033-.306l.002-2.968c0-.443 0-.78-.002-.86v-.039zM.406 10.8c-.009-.22-.057-.58-.057-.58H.255a.143.143 0 00-.144.146l.004 2.148c.001.08.096.154.176.154h.083c.004-.003.022-.029.033-.307l.002-.662c0-.443 0-.78-.002-.86V10.8z",
    fill: "#1F1E24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.925 0c3.632 0 5.57 2.081 5.57 5.712v52.81c0 3.514-2.288 5.41-5.86 5.41H6.088c-3.835 0-5.866-2.442-5.794-5.488V5.698C.294 2.068 2.376 0 6.008 0h19.917z",
    fill: "#1F1E24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.593.526c3.679 0 5.398 1.84 5.398 5.525v52.344c0 3.265-2.214 5.066-5.546 5.066H6.342C3.05 63.453.811 61.518.811 58.471V6.052C.81 2.368 2.664.526 6.342.526h19.252z",
    fill: "#060606",
    stroke: "#000",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.045,
    cy: 2.502,
    transform: "rotate(-74 19.045 2.502)",
    fill: "#003472",
    r: 0.297
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.072 1.657c.204 0 .353.166.353.371v.223c0 .9.727 1.703 1.624 1.703h11.907c.898 0 1.625-.802 1.625-1.703v-.223a.37.37 0 01.37-.37h3.023c1.59 0 2.935 1.726 2.935 3.324v53.963c0 1.728-1.45 3.397-3.365 3.397H5.39c-2.192 0-3.382-1.322-3.372-3.253V4.982c0-1.598 1.352-3.325 2.942-3.325h3.112z",
    fill: "#111"
  })));
}
export default SvgMobile;